import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { Checkbox } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import { updateRequestProperties } from '../actions';
import { rightsUrl } from '../helper';
import { newRequest, resolveRequestWorkflow } from '../state/state';

const labelText = (rights, compact) => {
  const label = rights ? 'access.terms.with.link' : 'access.terms.no.link';

  if (compact) {
    return `${label}.compact`;
  }

  return label;
};

const RequestTerms = ({
  category,
  code,
  compact,
  saveStatus,
  rights,
  terms,
  updateProperties,
}) => {
  const intl = useIntl();
  return (
    <div
      className={clsx(
        'aridhia-request-terms',
        compact ? 'aridhia-tab-actions-checkbox-compact' : 'aridhia-tab-actions-checkbox',
      )}
    >
      <Checkbox
        label={(
          <label htmlFor="request-terms-checkbox">
            {intl.formatMessage({ id: labelText(rights, compact) })}
            {rights && (
              <a href={rights} rel="noopener noreferrer" target="_blank">
                <FormattedMessage id="access.terms.link" />
              </a>
            )}
          </label>
        )}
        id="request-terms-checkbox"
        type="checkbox"
        onClick={() => updateProperties(category, code, { steps: { terms: !terms } })}
        checked={terms}
        disabled={saveStatus === states.PENDING}
      />

    </div>
  );
};

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request, source } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  const safeSource = source || { code: null };

  return ({
    rights: rightsUrl(safeSource),
    saveStatus: request.saveStatus,
    terms: request.steps.terms,
  });
};

const mapDispatchToProps = {
  updateProperties: updateRequestProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestTerms);
